import { css } from '@emotion/react';
import { IonCard, IonCardContent, IonIcon, IonItem, IonLabel, IonGrid, IonCol, IonRow } from '@ionic/react';
import React from 'react';
import CircleUrl from '../../assets/img/circle.svg';
import SquareUrl from '../../assets/img/square.svg';
import * as commonCss from '../../styles/common';
import PoweredBy from '../../components/PoweredBy';

export interface MapMarkerLegendProps {
  color: string;
  showReferenceSite: boolean;
}

const MapMarkerLegend: React.FC<MapMarkerLegendProps> = ({ color, showReferenceSite }) => {
  const legendStyles = {
    container: css({
      margin: '0px',
    }),
    col: css({
      padding: '5px 0',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }),
    item: [
      commonCss.smallText,
      commonCss.noPadding,
      css({
        display: 'flex',
        width: '10.5rem',
        '--min-height': '1.8rem',
        '--padding-start': '8px',
        '--padding-end': '8px',
      }),
    ],
    icon: [css({ margin: '0 8px 0 0', color })],
    label: css({
      margin: 0,
      textAlign: 'left',
    }),
    cardContent: css({
      padding: '0',
    }),
  };

  return (
    <IonCard css={legendStyles.container}>
      <IonCardContent css={legendStyles.cardContent}>
        <IonGrid css={commonCss.noPadding}>
          <IonRow>
            <IonCol size="auto" css={legendStyles.col}>
              <PoweredBy />
            </IonCol>
            <IonCol size="auto" css={legendStyles.col}>
              <IonItem lines="none" css={legendStyles.item}>
                <IonIcon src={CircleUrl} css={legendStyles.icon} slot="start" size="small" />
                <IonLabel css={legendStyles.label}>Clarity Sensor</IonLabel>
              </IonItem>
              {showReferenceSite && (
                <IonItem lines="none" css={legendStyles.item}>
                  <IonIcon src={SquareUrl} css={legendStyles.icon} slot="start" size="small" />
                  <IonLabel css={legendStyles.label}>Reference Monitor</IonLabel>
                </IonItem>
              )}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>
  );
};

export default MapMarkerLegend;
